<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Datos del destinatario
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center" style="color: #ff5855; font-weight: bolder">
                        <label>¿ESTÁN CORRECTOS LOS DATOS?</label> 
                    </div>
                </div>  
                
                <div class="row form-group" v-if="model.IsAddContact">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Nombre de Referencia</label>
                    </div>
                     <div class="col-md-12">                     
                        <base-input v-model="model.ReferenceName" readonly></base-input>
                    </div>
                </div>

                <div v-for="(item,index) in model.Destinatario.Contact.Owners" v-bind:key="index">
                    <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">
                            <label>Nombre</label>
                        </div>
                        <div class="col-md-12">
                            <base-input v-model = "item.Name" readonly></base-input>
                        </div>
                    </div>
                     <div class="row form-group">
                        <div class="col-md-12" style="font-weight: bolder">
                            <label v-text="item.IDType"></label>
                        </div>
                        <div class="col-md-12">
                            <base-input v-model = "item.CuitCuil" readonly></base-input>
                        </div>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>CBU/CVU</label>
                    </div>
                     <div class="col-md-12">
                        <base-input v-model="model.Destinatario.Contact.CBUCVU" readonly></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Alias</label>
                    </div>
                    <div class="col-md-12" >
                        <base-input v-model="model.Destinatario.Contact.Label" readonly></base-input>
                    </div>
                </div>

              <!--   <div class="row form-group">
                    <div class="col-md-12" style="font-weight: bolder">
                        <label>Banco</label>
                    </div>
                    <div class="col-md-12">
                        <base-input v-model="model.Destinatario.Contact.BankName" readonly></base-input>
                    </div>
                </div> -->
                
                <div class="row form-group" v-if="model.IsAddContact">
                    <div class="col-md-12 text-center">
                        <save-button text="Agregar Contacto" @click="agregarContacto"></save-button>
                    </div>
                </div>

                 <div class="row form-group" v-if="model.IsNotAddContact">
                    <div class="col-md-12 text-center">
                        <save-button v-text="model.ButtonActionText" @click="confirmarDestinatario"></save-button>
                    </div>
                </div>

                 <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="Volver" @click="goBack"></save-button>
                    </div>
                </div>
           
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    export default {
        props: {
            destinatario: null,
            isAddContact: Boolean,
            buttonActionText: String,
            modoTransferenciaID: Number,
            inputValue: String
        },
        data(){
            return {
                model: {
                    Destinatario: this.destinatario,
                    IsAddContact: this.isAddContact,
                    Title: '',
                    ReferenceName: '',
                    ButtonActionText: this.buttonActionText,
                    IsNotAddContact: false,
                    ModoTransferenciaID: this.modoTransferenciaID,
                    InputValue: this.inputValue
                }
            };
        },
        methods: {
            confirmarDestinatario() {
                let context = this;
                let contactName = '';
                let cuitCuil = '';

                if(context.model.Destinatario.Contact.Owners.length > 0)
                {
                    for(var i = 0; i <= context.model.Destinatario.Contact.Owners.length-1; i++) {
                        
                        if(context.model.Destinatario.Contact.Owners.length == i+ 1) {
                            contactName += context.model.Destinatario.Contact.Owners[i].Name;
                            cuitCuil += context.model.Destinatario.Contact.Owners[i].CuitCuil;
                        } else {
                            contactName += context.model.Destinatario.Contact.Owners[i].Name.concat(", ");
                            cuitCuil += context.model.Destinatario.Contact.Owners[i].CuitCuil.concat(", ");
                        }
                    }
                }

                context.$router.push({ name: "TransferAmount", params: 
                { 
                    bankName: context.model.Destinatario.Contact.BankName,
                    alias: context.model.ModoTransferenciaID == 2 ? context.model.InputValue : '',
                    cBUCVU: context.model.ModoTransferenciaID == 1 ? context.model.InputValue : context.model.Destinatario.Contact.CBUCVU,
                    contactName: contactName,
                    isAlias: context.model.ModoTransferenciaID == 2 ? true : false,
                    nameOwners: contactName,
                    cuitCuilOwners: cuitCuil
                }});
            },
            goBack()
            {
                let context = this;
                context.$router.push("dashboard");
            },     
        },
        mounted() {
            let context = this;
            context.model.Title = context.model.IsAddContact == true ? "Nuevo Destinatario" : "Datos del Destinatario";
            context.model.IsNotAddContact = !context.model.IsAddContact;
        }
    }
</script>